module.exports = __webpack_public_path__ + "static/inline-04e91d9f418c190a56646ccf88be2966.png";